import React, { useContext } from "react";
import { TScreen } from "api/type";

// Import Assets
import UploadPhotoInstructionStepOne from "assets/UploadPhotoInstructionStepOne.icon";
import UploadPhotoInstructionStepTwo from "assets/UploadPhotoInstructionStepTwo.icon";

// Import Contexts
import ScreenContext from "contexts/screen";

// Import Components
import { NormalText, TitleBar, PrimaryButton } from "components/index";

type ScreenUploadPhotoInstructionProps = {};

const ScreenUploadPhotoInstruction: React.FC<
  ScreenUploadPhotoInstructionProps
> = () => {
  const setScreen = useContext(ScreenContext)[1];

  return (
    <div className="screen-container">
      <TitleBar
        name={"Instructions"}
        onClickBackButton={() => setScreen(TScreen.SELECT_UPLOAD_TYPE_SCREEN)}
      />
      <NormalText textContent={"Use these instructions when taking photos."} />
      <div style={styles.screenContainer}>
        <div style={styles.stepContainer}>
          <div>
            <UploadPhotoInstructionStepOne />
          </div>
          <div>
            <NormalText textContent={"Step 1:"} style={styles.boldText} />
            <NormalText
              textContent={
                "Put the camera down on a surface waist high. Remove garments covering area of interest."
              }
            />
          </div>
        </div>
        <div style={styles.stepContainer}>
          <div>
            <UploadPhotoInstructionStepTwo />
          </div>
          <div>
            <NormalText textContent={"Step 2:"} style={styles.boldText} />
            <NormalText
              textContent={
                "Take a step back and align yourself with the on-screen guide. A timer will count down."
              }
            />
          </div>
        </div>
      </div>
      <PrimaryButton
        onClick={() => setScreen(TScreen.PHOTO_UPLOAD_SCREEN)}
        fullWidth
        text={"Upload photos"}
      />
    </div>
  );
};

const styles = {
  screenContainer: {
    display: "flex",
    flexDirection: "column" as const,
    gap: 20,
    margin: "auto",
  },
  stepContainer: {
    display: "flex",
    flexDirection: "row" as const,
    gap: 16,
  },
  boldText: {
    fontWeight: 700,
  },
};

export default ScreenUploadPhotoInstruction;
